import React from 'react'
import styled from 'styled-components'
import { margin, MarginProps } from 'styled-system'

import IconButton from '../IconButton'

type Props = MarginProps & {
  customCancel?: React.ReactNode
  customConfirm?: React.ReactNode
  isCancelDisabled?: boolean
  isConfirmDisabled?: boolean
  onClickCancel?: () => void
  onClickConfirm?: () => void
}

const InlineInputButtons: React.FC<Props> = ({
  customCancel,
  customConfirm,
  isCancelDisabled,
  isConfirmDisabled,
  onClickCancel,
  onClickConfirm,
  ...marginProps
}) => (
  <Container {...marginProps}>
    {customCancel ? (
      customCancel
    ) : (
      <IconButton disabled={isCancelDisabled} icon={['far', 'times']} onClick={onClickCancel} variant="xButtonRed" />
    )}
    {customConfirm ? (
      customConfirm
    ) : (
      <IconButton
        disabled={isConfirmDisabled}
        icon={['fa', 'check']}
        onClick={onClickConfirm}
        variant="checkButtonGreen"
      />
    )}
  </Container>
)

const Container = styled.div<MarginProps>`
  ${margin}
  background: ${(p) => p.theme.colors.white};
  display: flex;
  gap: 2px;
  justify-content: flex-end;
  position: absolute;
  right: 4px;
  z-index: 1;
`

export default InlineInputButtons
